import React, { useState } from 'react'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { CalculatorIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CalculatorIcon'
import { ShevronDownIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronDownIcon'
import { ShevronUpIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronUpIcon'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import { AdvancePaymentCalculatorFormulaTerm } from './components/AdvancePaymentCalculatorFormulaTerm'
import { messages } from './messages'
import type { TAdvancePaymentCalculatorFormulaProps } from './types'
import './styles.scss'

export const AdvancePaymentCalculatorFormula: React.FC<TAdvancePaymentCalculatorFormulaProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClickTrigger = () => {
    setIsOpen(state => !state)
  }

  return (
    <div className={classNames('advancePaymentCalculatorFormula', className)}>
      <Button className="advancePaymentCalculatorFormula__trigger" onClick={handleClickTrigger} isUnstyled>
        <Icon className="advancePaymentCalculatorFormula__triggerCalculator" component={<CalculatorIcon />} />
        <span className="advancePaymentCalculatorFormula__triggerTitle">{messages.trigger.title}</span>
        <Icon
          className="advancePaymentCalculatorFormula__triggerIcon"
          component={isOpen ? <ShevronUpIcon /> : <ShevronDownIcon />}
          size={EIconSize.L}
        />
      </Button>
      {isOpen && (
        <div className="advancePaymentCalculatorFormula__content">
          <div className="advancePaymentCalculatorFormula__blocks">
            <AdvancePaymentCalculatorFormulaTerm className="advancePaymentCalculatorFormula__sum" title={messages.formula.sum} />
            <div className="advancePaymentCalculatorFormula__operator">{messages.formula.operator.equal}</div>
            <div className="advancePaymentCalculatorFormula__firstMultiplier">
              <AdvancePaymentCalculatorFormulaTerm
                className="advancePaymentCalculatorFormula__auctions"
                title={messages.formula.auctions.title}
                description={messages.formula.auctions.text}
              />
              <div className="advancePaymentCalculatorFormula__operator advancePaymentCalculatorFormula__operator--minus">
                {messages.formula.operator.minus}
              </div>
              <AdvancePaymentCalculatorFormulaTerm
                className="advancePaymentCalculatorFormula__storageCosts"
                title={
                  <span>
                    {messages.formula.storageCosts}
                    <span className="advancePaymentCalculatorFormula__warningSign">{messages.warning.sign}</span>
                  </span>
                }
              />
              <div className="advancePaymentCalculatorFormula__operator advancePaymentCalculatorFormula__operator--minus">
                {messages.formula.operator.minus}
              </div>
              <AdvancePaymentCalculatorFormulaTerm
                className="advancePaymentCalculatorFormula__railwayTariff"
                title={
                  <span>
                    {messages.formula.railwayTariff}
                    <span className="advancePaymentCalculatorFormula__warningSign">{messages.warning.sign}</span>
                  </span>
                }
              />
            </div>
            <div className="advancePaymentCalculatorFormula__operator advancePaymentCalculatorFormula__operator--multiply">
              {messages.formula.operator.multiply}
            </div>
            <AdvancePaymentCalculatorFormulaTerm
              className="advancePaymentCalculatorFormula__discount"
              title={messages.formula.discount.title}
              description={messages.formula.discount.text}
            />
          </div>
          <div className="advancePaymentCalculatorFormula__warning text_super-small">
            <span className="advancePaymentCalculatorFormula__warningSign">{messages.warning.sign}</span>
            <span>{messages.warning.text}</span>
          </div>
        </div>
      )}
    </div>
  )
}
